// 文章类型映射
export const articleTypeMap = {
    THE_LATEST_FROM_BIGO: {
        value: '1',
        msg: 'THE LATEST FROM BIGO'
      },
      BIGO_ON_THE_MEDIA: {
        value: '2',
        msg: 'BIGO ON THE MEDIA'
      },
      CREATOR_STORIES: {
        value: '3',
        msg: 'CREATOR STORIES'
      }
}